<template>
  <div class="userTreaty">
    <Header :headerTitle="$t('m.oilicyPage.title')"></Header>
    <ul>
      <li class="indent textBottom">{{ $t("m.oilicyPage.context1") }}</li>
      <li class="indent textBottom">
        {{ $t("m.oilicyPage.context2") }}
      </li>
      <li class="indent textBottom">{{ $t("m.oilicyPage.context3") }}</li>
      <li class="indent textBottom">{{ $t("m.oilicyPage.context4") }}</li>
      <li class="indent textBottom">{{ $t("m.oilicyPage.context5") }}</li>
      <li class="indent">{{ $t("m.oilicyPage.context6") }}</li>
      <li>{{ $t("m.oilicyPage.li1") }}</li>
      <li>{{ $t("m.oilicyPage.li2") }}</li>
      <li>{{ $t("m.oilicyPage.li3") }}</li>
      <li>{{ $t("m.oilicyPage.li4") }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Policy",
  data() {
    return {};
  },
};
</script>
<style scoped>
.userTreaty{
  height: calc(100%);
  overflow: auto;
}
.userTreaty h5 {
  margin-top: 15px;
  font-size: 1.1rem;
}
.userTreaty ul {
  margin: 0 auto;
  margin-top: 15px;
  list-style: none;
  text-align: left;
  padding: 0 10px;
  font-size: 0.96rem;
  margin-bottom: 20px;
}
.userTreaty .indent {
  text-indent: 2em;
}
.userTreaty .textBottom {
  margin-bottom: 10px;
  margin-top: 20px;
}
.userTreaty .row {
  /* margin: 5px 0; */
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0 15px;
  font-size: 0.91rem;
}
.userTreaty .row .col-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
  margin-right: 4.5px;
  max-width: 23.5%;
}
.userTreaty .row .col-6 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
}
.userTreaty .row .col-12 {
  background-color: #f1f1f1;
  margin-bottom: 3px;
  padding: 0 1px;
}
.userTreaty .row .col-12 p {
  margin: 0;
  font-size: 0.93rem;
}
.userTreaty .row .col-12 ul {
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
  text-align: left;
}
.userTreaty .row .col-12 ul li span {
  float: left;
  margin-top: -1px;
  padding-right: 4px;
}
</style>
